




















































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { create } from '@/util/createApi';
import { uuid } from '@/util/uuid';
@Component({
  components: {},
})
export default class ChoiceText extends Vue {
  @Prop(Number) unitId: any;
  private dataText: any = '';
  private drawer = false;

  private optionId = 1; // 选项Id
  private optionsList: any = []; // 选项列表

  @Prop() private formProp: any;

  private form: any = {};

  mounted() {
    if (JSON.stringify(this.formProp) == '{}') {
      this.form = {
        id: uuid(),
        label: '多选+文本',
        placeholder: '请选择',
        required: true,
        spread: false,
        options: [],
      };
      this.$nextTick(() => {
        this.$emit('unit_set_data', { id: this.unitId, form: this.form });
      });
    } else {
      this.form = this.formProp;
    }
    console.log(this.form);
  }

  closeTap() {
    console.log(this.unitId);
    this.$emit('i_close', { id: this.unitId });
  }

  // 添加选项  待完善
  addOption() {
    const obj: any = {
      value: uuid(),
      label: '',
    };
    this.form.options.push(obj);
    this.$forceUpdate();
  }

  removeOption(i: number) {
    const index = this.form.options.indexOf(i);
    this.form.options.splice(index, 1);
  }
}
